import { interpolatePath } from './linkHelpers';
// PUBLIC API
export const routes = {
    LandingPageRoute: {
        to: "/",
        build: (options) => interpolatePath("/", undefined, options?.search, options?.hash),
    },
    LoginRoute: {
        to: "/login",
        build: (options) => interpolatePath("/login", undefined, options?.search, options?.hash),
    },
    SignupRoute: {
        to: "/signup",
        build: (options) => interpolatePath("/signup", undefined, options?.search, options?.hash),
    },
    RequestPasswordResetRoute: {
        to: "/request-password-reset",
        build: (options) => interpolatePath("/request-password-reset", undefined, options?.search, options?.hash),
    },
    PasswordResetRoute: {
        to: "/password-reset",
        build: (options) => interpolatePath("/password-reset", undefined, options?.search, options?.hash),
    },
    EmailVerificationRoute: {
        to: "/email-verification",
        build: (options) => interpolatePath("/email-verification", undefined, options?.search, options?.hash),
    },
    PrivacyRoute: {
        to: "/privacy",
        build: (options) => interpolatePath("/privacy", undefined, options?.search, options?.hash),
    },
    TermsRoute: {
        to: "/terms",
        build: (options) => interpolatePath("/terms", undefined, options?.search, options?.hash),
    },
    ContactRoute: {
        to: "/contact",
        build: (options) => interpolatePath("/contact", undefined, options?.search, options?.hash),
    },
    AboutRoute: {
        to: "/about",
        build: (options) => interpolatePath("/about", undefined, options?.search, options?.hash),
    },
    AccountRoute: {
        to: "/account",
        build: (options) => interpolatePath("/account", undefined, options?.search, options?.hash),
    },
    DashboardRoute: {
        to: "/dashboard",
        build: (options) => interpolatePath("/dashboard", undefined, options?.search, options?.hash),
    },
    DemoSchedulerRoute: {
        to: "/tools/scheduler",
        build: (options) => interpolatePath("/tools/scheduler", undefined, options?.search, options?.hash),
    },
    PricingPageRoute: {
        to: "/pricing",
        build: (options) => interpolatePath("/pricing", undefined, options?.search, options?.hash),
    },
    CheckoutRoute: {
        to: "/checkout",
        build: (options) => interpolatePath("/checkout", undefined, options?.search, options?.hash),
    },
    FileUploadRoute: {
        to: "/file-upload",
        build: (options) => interpolatePath("/file-upload", undefined, options?.search, options?.hash),
    },
    AdminRoute: {
        to: "/admin",
        build: (options) => interpolatePath("/admin", undefined, options?.search, options?.hash),
    },
    AdminUsersRoute: {
        to: "/admin/users",
        build: (options) => interpolatePath("/admin/users", undefined, options?.search, options?.hash),
    },
    AdminUserDetailRoute: {
        to: "/admin/users/:userId",
        build: (options) => interpolatePath("/admin/users/:userId", options.params, options?.search, options?.hash),
    },
    AdminUserEditRoute: {
        to: "/admin/users/:userId/edit",
        build: (options) => interpolatePath("/admin/users/:userId/edit", options.params, options?.search, options?.hash),
    },
    AdminSettingsRoute: {
        to: "/admin/settings",
        build: (options) => interpolatePath("/admin/settings", undefined, options?.search, options?.hash),
    },
    AdminCalendarRoute: {
        to: "/admin/calendar",
        build: (options) => interpolatePath("/admin/calendar", undefined, options?.search, options?.hash),
    },
    AdminUIButtonsRoute: {
        to: "/admin/ui/buttons",
        build: (options) => interpolatePath("/admin/ui/buttons", undefined, options?.search, options?.hash),
    },
    AdminDomainsRoute: {
        to: "/admin/domains",
        build: (options) => interpolatePath("/admin/domains", undefined, options?.search, options?.hash),
    },
    AdminGeoBlockingRoute: {
        to: "/admin/geoblocking",
        build: (options) => interpolatePath("/admin/geoblocking", undefined, options?.search, options?.hash),
    },
    AdminMessagesRoute: {
        to: "/admin/messages",
        build: (options) => interpolatePath("/admin/messages", undefined, options?.search, options?.hash),
    },
    TestDashboardRoute: {
        to: "/test-dashboard",
        build: (options) => interpolatePath("/test-dashboard", undefined, options?.search, options?.hash),
    },
    LocationLandingRoute: {
        to: "/locations/:slug",
        build: (options) => interpolatePath("/locations/:slug", options.params, options?.search, options?.hash),
    },
    LocationDashboardRoute: {
        to: "/locations/:slug/dashboard",
        build: (options) => interpolatePath("/locations/:slug/dashboard", options.params, options?.search, options?.hash),
    },
    AdminLocationsRoute: {
        to: "/admin/locations",
        build: (options) => interpolatePath("/admin/locations", undefined, options?.search, options?.hash),
    },
    AdminLocationEntriesRoute: {
        to: "/admin/locations/:locationId/entries",
        build: (options) => interpolatePath("/admin/locations/:locationId/entries", options.params, options?.search, options?.hash),
    },
    CreateLocationRoute: {
        to: "/admin/locations/new",
        build: (options) => interpolatePath("/admin/locations/new", undefined, options?.search, options?.hash),
    },
    EditLocationRoute: {
        to: "/admin/locations/:id/edit",
        build: (options) => interpolatePath("/admin/locations/:id/edit", options.params, options?.search, options?.hash),
    },
    AdminLocationTypesRoute: {
        to: "/admin/location-types",
        build: (options) => interpolatePath("/admin/location-types", undefined, options?.search, options?.hash),
    },
    AdminSectionFieldVisibilityRoute: {
        to: "/admin/section-visibility/fields/:sectionKey",
        build: (options) => interpolatePath("/admin/section-visibility/fields/:sectionKey", options.params, options?.search, options?.hash),
    },
    AdminPlatformSectionVisibilityRoute: {
        to: "/admin/section-visibility",
        build: (options) => interpolatePath("/admin/section-visibility", undefined, options?.search, options?.hash),
    },
    CreateLocationTypeRoute: {
        to: "/admin/location-types/new",
        build: (options) => interpolatePath("/admin/location-types/new", undefined, options?.search, options?.hash),
    },
    EventsRoute: {
        to: "/events",
        build: (options) => interpolatePath("/events", undefined, options?.search, options?.hash),
    },
    LocationEventsRoute: {
        to: "/locations/:slug/events",
        build: (options) => interpolatePath("/locations/:slug/events", options.params, options?.search, options?.hash),
    },
    AddEventRoute: {
        to: "/events/add",
        build: (options) => interpolatePath("/events/add", undefined, options?.search, options?.hash),
    },
    LocationAddEventRoute: {
        to: "/locations/:slug/events/add",
        build: (options) => interpolatePath("/locations/:slug/events/add", options.params, options?.search, options?.hash),
    },
    EditEventRoute: {
        to: "/events/:eventId/edit",
        build: (options) => interpolatePath("/events/:eventId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditEventRoute: {
        to: "/locations/:slug/events/:eventId/edit",
        build: (options) => interpolatePath("/locations/:slug/events/:eventId/edit", options.params, options?.search, options?.hash),
    },
    ViewEventRoute: {
        to: "/events/:eventId",
        build: (options) => interpolatePath("/events/:eventId", options.params, options?.search, options?.hash),
    },
    LocationViewEventRoute: {
        to: "/locations/:slug/events/:eventId",
        build: (options) => interpolatePath("/locations/:slug/events/:eventId", options.params, options?.search, options?.hash),
    },
    TenantsRoute: {
        to: "/tenants",
        build: (options) => interpolatePath("/tenants", undefined, options?.search, options?.hash),
    },
    LocationTenantsRoute: {
        to: "/locations/:slug/tenants",
        build: (options) => interpolatePath("/locations/:slug/tenants", options.params, options?.search, options?.hash),
    },
    AddTenantRoute: {
        to: "/tenants/add",
        build: (options) => interpolatePath("/tenants/add", undefined, options?.search, options?.hash),
    },
    LocationAddTenantRoute: {
        to: "/locations/:slug/tenants/add",
        build: (options) => interpolatePath("/locations/:slug/tenants/add", options.params, options?.search, options?.hash),
    },
    EditTenantRoute: {
        to: "/tenants/:tenantId/edit",
        build: (options) => interpolatePath("/tenants/:tenantId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditTenantRoute: {
        to: "/locations/:slug/tenants/:tenantId/edit",
        build: (options) => interpolatePath("/locations/:slug/tenants/:tenantId/edit", options.params, options?.search, options?.hash),
    },
    ViewTenantRoute: {
        to: "/tenants/:tenantId",
        build: (options) => interpolatePath("/tenants/:tenantId", options.params, options?.search, options?.hash),
    },
    LocationViewTenantRoute: {
        to: "/locations/:slug/tenants/:tenantId",
        build: (options) => interpolatePath("/locations/:slug/tenants/:tenantId", options.params, options?.search, options?.hash),
    },
    NoticeBoardRoute: {
        to: "/notices",
        build: (options) => interpolatePath("/notices", undefined, options?.search, options?.hash),
    },
    LocationNoticeBoardRoute: {
        to: "/locations/:slug/notices",
        build: (options) => interpolatePath("/locations/:slug/notices", options.params, options?.search, options?.hash),
    },
    AddNoticeRoute: {
        to: "/notices/add",
        build: (options) => interpolatePath("/notices/add", undefined, options?.search, options?.hash),
    },
    LocationAddNoticeRoute: {
        to: "/locations/:slug/notices/add",
        build: (options) => interpolatePath("/locations/:slug/notices/add", options.params, options?.search, options?.hash),
    },
    EditNoticeRoute: {
        to: "/notices/:noticeId/edit",
        build: (options) => interpolatePath("/notices/:noticeId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditNoticeRoute: {
        to: "/locations/:slug/notices/:noticeId/edit",
        build: (options) => interpolatePath("/locations/:slug/notices/:noticeId/edit", options.params, options?.search, options?.hash),
    },
    ViewNoticeRoute: {
        to: "/notices/:noticeId",
        build: (options) => interpolatePath("/notices/:noticeId", options.params, options?.search, options?.hash),
    },
    LocationViewNoticeRoute: {
        to: "/locations/:slug/notices/:noticeId",
        build: (options) => interpolatePath("/locations/:slug/notices/:noticeId", options.params, options?.search, options?.hash),
    },
    FacilitiesRoute: {
        to: "/facilities",
        build: (options) => interpolatePath("/facilities", undefined, options?.search, options?.hash),
    },
    LocationFacilitiesRoute: {
        to: "/locations/:slug/facilities",
        build: (options) => interpolatePath("/locations/:slug/facilities", options.params, options?.search, options?.hash),
    },
    AddFacilityRoute: {
        to: "/facilities/add",
        build: (options) => interpolatePath("/facilities/add", undefined, options?.search, options?.hash),
    },
    LocationAddFacilityRoute: {
        to: "/locations/:slug/facilities/add",
        build: (options) => interpolatePath("/locations/:slug/facilities/add", options.params, options?.search, options?.hash),
    },
    EditFacilityRoute: {
        to: "/facilities/:facilityId/edit",
        build: (options) => interpolatePath("/facilities/:facilityId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditFacilityRoute: {
        to: "/locations/:slug/facilities/:facilityId/edit",
        build: (options) => interpolatePath("/locations/:slug/facilities/:facilityId/edit", options.params, options?.search, options?.hash),
    },
    ViewFacilityRoute: {
        to: "/facilities/:facilityId",
        build: (options) => interpolatePath("/facilities/:facilityId", options.params, options?.search, options?.hash),
    },
    LocationViewFacilityRoute: {
        to: "/locations/:slug/facilities/:facilityId",
        build: (options) => interpolatePath("/locations/:slug/facilities/:facilityId", options.params, options?.search, options?.hash),
    },
    BuySellRoute: {
        to: "/buy-sell",
        build: (options) => interpolatePath("/buy-sell", undefined, options?.search, options?.hash),
    },
    LocationBuySellRoute: {
        to: "/locations/:slug/buy-sell",
        build: (options) => interpolatePath("/locations/:slug/buy-sell", options.params, options?.search, options?.hash),
    },
    AddBuySellRoute: {
        to: "/buy-sell/add",
        build: (options) => interpolatePath("/buy-sell/add", undefined, options?.search, options?.hash),
    },
    LocationAddBuySellRoute: {
        to: "/locations/:slug/buy-sell/add",
        build: (options) => interpolatePath("/locations/:slug/buy-sell/add", options.params, options?.search, options?.hash),
    },
    EditBuySellRoute: {
        to: "/buy-sell/:itemId/edit",
        build: (options) => interpolatePath("/buy-sell/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditBuySellRoute: {
        to: "/locations/:slug/buy-sell/:itemId/edit",
        build: (options) => interpolatePath("/locations/:slug/buy-sell/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewBuySellRoute: {
        to: "/buy-sell/:itemId",
        build: (options) => interpolatePath("/buy-sell/:itemId", options.params, options?.search, options?.hash),
    },
    LocationViewBuySellRoute: {
        to: "/locations/:slug/buy-sell/:itemId",
        build: (options) => interpolatePath("/locations/:slug/buy-sell/:itemId", options.params, options?.search, options?.hash),
    },
    FoodCourtRoute: {
        to: "/food-court",
        build: (options) => interpolatePath("/food-court", undefined, options?.search, options?.hash),
    },
    LocationFoodCourtRoute: {
        to: "/locations/:slug/food-court",
        build: (options) => interpolatePath("/locations/:slug/food-court", options.params, options?.search, options?.hash),
    },
    AddFoodCourtRoute: {
        to: "/food-court/add",
        build: (options) => interpolatePath("/food-court/add", undefined, options?.search, options?.hash),
    },
    LocationAddFoodCourtRoute: {
        to: "/locations/:slug/food-court/add",
        build: (options) => interpolatePath("/locations/:slug/food-court/add", options.params, options?.search, options?.hash),
    },
    EditFoodCourtRoute: {
        to: "/food-court/:itemId/edit",
        build: (options) => interpolatePath("/food-court/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditFoodCourtRoute: {
        to: "/locations/:slug/food-court/:itemId/edit",
        build: (options) => interpolatePath("/locations/:slug/food-court/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewFoodCourtRoute: {
        to: "/food-court/:itemId",
        build: (options) => interpolatePath("/food-court/:itemId", options.params, options?.search, options?.hash),
    },
    LocationViewFoodCourtRoute: {
        to: "/locations/:slug/food-court/:itemId",
        build: (options) => interpolatePath("/locations/:slug/food-court/:itemId", options.params, options?.search, options?.hash),
    },
    TextbooksRoute: {
        to: "/textbooks",
        build: (options) => interpolatePath("/textbooks", undefined, options?.search, options?.hash),
    },
    LocationTextbooksRoute: {
        to: "/locations/:slug/textbooks",
        build: (options) => interpolatePath("/locations/:slug/textbooks", options.params, options?.search, options?.hash),
    },
    AddTextbookRoute: {
        to: "/textbooks/add",
        build: (options) => interpolatePath("/textbooks/add", undefined, options?.search, options?.hash),
    },
    LocationAddTextbookRoute: {
        to: "/locations/:slug/textbooks/add",
        build: (options) => interpolatePath("/locations/:slug/textbooks/add", options.params, options?.search, options?.hash),
    },
    ViewTextbookRoute: {
        to: "/textbooks/:itemId",
        build: (options) => interpolatePath("/textbooks/:itemId", options.params, options?.search, options?.hash),
    },
    LocationViewTextbookRoute: {
        to: "/locations/:slug/textbooks/:itemId",
        build: (options) => interpolatePath("/locations/:slug/textbooks/:itemId", options.params, options?.search, options?.hash),
    },
    EditTextbookRoute: {
        to: "/textbooks/:itemId/edit",
        build: (options) => interpolatePath("/textbooks/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditTextbookRoute: {
        to: "/locations/:slug/textbooks/:itemId/edit",
        build: (options) => interpolatePath("/locations/:slug/textbooks/:itemId/edit", options.params, options?.search, options?.hash),
    },
    AccommodationRoute: {
        to: "/accommodation",
        build: (options) => interpolatePath("/accommodation", undefined, options?.search, options?.hash),
    },
    LocationAccommodationRoute: {
        to: "/locations/:slug/accommodation",
        build: (options) => interpolatePath("/locations/:slug/accommodation", options.params, options?.search, options?.hash),
    },
    AddAccommodationRoute: {
        to: "/accommodation/add",
        build: (options) => interpolatePath("/accommodation/add", undefined, options?.search, options?.hash),
    },
    LocationAddAccommodationRoute: {
        to: "/locations/:slug/accommodation/add",
        build: (options) => interpolatePath("/locations/:slug/accommodation/add", options.params, options?.search, options?.hash),
    },
    ViewAccommodationRoute: {
        to: "/accommodation/:itemId",
        build: (options) => interpolatePath("/accommodation/:itemId", options.params, options?.search, options?.hash),
    },
    LocationViewAccommodationRoute: {
        to: "/locations/:slug/accommodation/:itemId",
        build: (options) => interpolatePath("/locations/:slug/accommodation/:itemId", options.params, options?.search, options?.hash),
    },
    EditAccommodationRoute: {
        to: "/accommodation/:itemId/edit",
        build: (options) => interpolatePath("/accommodation/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditAccommodationRoute: {
        to: "/locations/:slug/accommodation/:itemId/edit",
        build: (options) => interpolatePath("/locations/:slug/accommodation/:itemId/edit", options.params, options?.search, options?.hash),
    },
    RequestOfferRoute: {
        to: "/request-offer",
        build: (options) => interpolatePath("/request-offer", undefined, options?.search, options?.hash),
    },
    LocationRequestOfferRoute: {
        to: "/locations/:slug/request-offer",
        build: (options) => interpolatePath("/locations/:slug/request-offer", options.params, options?.search, options?.hash),
    },
    AddRequestOfferRoute: {
        to: "/request-offer/add",
        build: (options) => interpolatePath("/request-offer/add", undefined, options?.search, options?.hash),
    },
    LocationAddRequestOfferRoute: {
        to: "/locations/:slug/request-offer/add",
        build: (options) => interpolatePath("/locations/:slug/request-offer/add", options.params, options?.search, options?.hash),
    },
    EditRequestOfferRoute: {
        to: "/request-offer/:itemId/edit",
        build: (options) => interpolatePath("/request-offer/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditRequestOfferRoute: {
        to: "/locations/:slug/request-offer/:itemId/edit",
        build: (options) => interpolatePath("/locations/:slug/request-offer/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewRequestOfferRoute: {
        to: "/request-offer/:itemId",
        build: (options) => interpolatePath("/request-offer/:itemId", options.params, options?.search, options?.hash),
    },
    LocationViewRequestOfferRoute: {
        to: "/locations/:slug/request-offer/:itemId",
        build: (options) => interpolatePath("/locations/:slug/request-offer/:itemId", options.params, options?.search, options?.hash),
    },
    CarpoolRoute: {
        to: "/carpooling",
        build: (options) => interpolatePath("/carpooling", undefined, options?.search, options?.hash),
    },
    LocationCarpoolRoute: {
        to: "/locations/:slug/carpooling",
        build: (options) => interpolatePath("/locations/:slug/carpooling", options.params, options?.search, options?.hash),
    },
    AddCarpoolRoute: {
        to: "/carpooling/add",
        build: (options) => interpolatePath("/carpooling/add", undefined, options?.search, options?.hash),
    },
    LocationAddCarpoolRoute: {
        to: "/locations/:slug/carpooling/add",
        build: (options) => interpolatePath("/locations/:slug/carpooling/add", options.params, options?.search, options?.hash),
    },
    EditCarpoolRoute: {
        to: "/carpooling/:itemId/edit",
        build: (options) => interpolatePath("/carpooling/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditCarpoolRoute: {
        to: "/locations/:slug/carpooling/:itemId/edit",
        build: (options) => interpolatePath("/locations/:slug/carpooling/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewCarpoolRoute: {
        to: "/carpooling/:itemId",
        build: (options) => interpolatePath("/carpooling/:itemId", options.params, options?.search, options?.hash),
    },
    LocationViewCarpoolRoute: {
        to: "/locations/:slug/carpooling/:itemId",
        build: (options) => interpolatePath("/locations/:slug/carpooling/:itemId", options.params, options?.search, options?.hash),
    },
    LostFoundRoute: {
        to: "/lost-found",
        build: (options) => interpolatePath("/lost-found", undefined, options?.search, options?.hash),
    },
    LocationLostFoundRoute: {
        to: "/locations/:slug/lost-found",
        build: (options) => interpolatePath("/locations/:slug/lost-found", options.params, options?.search, options?.hash),
    },
    AddLostFoundRoute: {
        to: "/lost-found/add",
        build: (options) => interpolatePath("/lost-found/add", undefined, options?.search, options?.hash),
    },
    LocationAddLostFoundRoute: {
        to: "/locations/:slug/lost-found/add",
        build: (options) => interpolatePath("/locations/:slug/lost-found/add", options.params, options?.search, options?.hash),
    },
    EditLostFoundRoute: {
        to: "/lost-found/:itemId/edit",
        build: (options) => interpolatePath("/lost-found/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditLostFoundRoute: {
        to: "/locations/:slug/lost-found/:itemId/edit",
        build: (options) => interpolatePath("/locations/:slug/lost-found/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewLostFoundRoute: {
        to: "/lost-found/:itemId",
        build: (options) => interpolatePath("/lost-found/:itemId", options.params, options?.search, options?.hash),
    },
    LocationViewLostFoundRoute: {
        to: "/locations/:slug/lost-found/:itemId",
        build: (options) => interpolatePath("/locations/:slug/lost-found/:itemId", options.params, options?.search, options?.hash),
    },
    ImmediateHelpRoute: {
        to: "/immediate-help",
        build: (options) => interpolatePath("/immediate-help", undefined, options?.search, options?.hash),
    },
    LocationImmediateHelpRoute: {
        to: "/locations/:slug/immediate-help",
        build: (options) => interpolatePath("/locations/:slug/immediate-help", options.params, options?.search, options?.hash),
    },
    AddImmediateHelpRoute: {
        to: "/immediate-help/add",
        build: (options) => interpolatePath("/immediate-help/add", undefined, options?.search, options?.hash),
    },
    LocationAddImmediateHelpRoute: {
        to: "/locations/:slug/immediate-help/add",
        build: (options) => interpolatePath("/locations/:slug/immediate-help/add", options.params, options?.search, options?.hash),
    },
    EditImmediateHelpRoute: {
        to: "/immediate-help/:itemId/edit",
        build: (options) => interpolatePath("/immediate-help/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditImmediateHelpRoute: {
        to: "/locations/:slug/immediate-help/:itemId/edit",
        build: (options) => interpolatePath("/locations/:slug/immediate-help/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewImmediateHelpRoute: {
        to: "/immediate-help/:itemId",
        build: (options) => interpolatePath("/immediate-help/:itemId", options.params, options?.search, options?.hash),
    },
    LocationViewImmediateHelpRoute: {
        to: "/locations/:slug/immediate-help/:itemId",
        build: (options) => interpolatePath("/locations/:slug/immediate-help/:itemId", options.params, options?.search, options?.hash),
    },
    AskForHelpRoute: {
        to: "/ask-for-help",
        build: (options) => interpolatePath("/ask-for-help", undefined, options?.search, options?.hash),
    },
    LocationAskForHelpRoute: {
        to: "/locations/:slug/ask-for-help",
        build: (options) => interpolatePath("/locations/:slug/ask-for-help", options.params, options?.search, options?.hash),
    },
    AddAskForHelpRoute: {
        to: "/ask-for-help/add",
        build: (options) => interpolatePath("/ask-for-help/add", undefined, options?.search, options?.hash),
    },
    LocationAddAskForHelpRoute: {
        to: "/locations/:slug/ask-for-help/add",
        build: (options) => interpolatePath("/locations/:slug/ask-for-help/add", options.params, options?.search, options?.hash),
    },
    EditAskForHelpRoute: {
        to: "/ask-for-help/:itemId/edit",
        build: (options) => interpolatePath("/ask-for-help/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditAskForHelpRoute: {
        to: "/locations/:slug/ask-for-help/:itemId/edit",
        build: (options) => interpolatePath("/locations/:slug/ask-for-help/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewAskForHelpRoute: {
        to: "/ask-for-help/:itemId",
        build: (options) => interpolatePath("/ask-for-help/:itemId", options.params, options?.search, options?.hash),
    },
    LocationViewAskForHelpRoute: {
        to: "/locations/:slug/ask-for-help/:itemId",
        build: (options) => interpolatePath("/locations/:slug/ask-for-help/:itemId", options.params, options?.search, options?.hash),
    },
    ShareWithNeighborsRoute: {
        to: "/share-with-neighbors",
        build: (options) => interpolatePath("/share-with-neighbors", undefined, options?.search, options?.hash),
    },
    LocationShareWithNeighborsRoute: {
        to: "/locations/:slug/share-with-neighbors",
        build: (options) => interpolatePath("/locations/:slug/share-with-neighbors", options.params, options?.search, options?.hash),
    },
    AddShareWithNeighborsRoute: {
        to: "/share-with-neighbors/add",
        build: (options) => interpolatePath("/share-with-neighbors/add", undefined, options?.search, options?.hash),
    },
    LocationAddShareWithNeighborsRoute: {
        to: "/locations/:slug/share-with-neighbors/add",
        build: (options) => interpolatePath("/locations/:slug/share-with-neighbors/add", options.params, options?.search, options?.hash),
    },
    EditShareWithNeighborsRoute: {
        to: "/share-with-neighbors/:itemId/edit",
        build: (options) => interpolatePath("/share-with-neighbors/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditShareWithNeighborsRoute: {
        to: "/locations/:slug/share-with-neighbors/:itemId/edit",
        build: (options) => interpolatePath("/locations/:slug/share-with-neighbors/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewShareWithNeighborsRoute: {
        to: "/share-with-neighbors/:itemId",
        build: (options) => interpolatePath("/share-with-neighbors/:itemId", options.params, options?.search, options?.hash),
    },
    LocationViewShareWithNeighborsRoute: {
        to: "/locations/:slug/share-with-neighbors/:itemId",
        build: (options) => interpolatePath("/locations/:slug/share-with-neighbors/:itemId", options.params, options?.search, options?.hash),
    },
    OtherRequestsRoute: {
        to: "/other-requests",
        build: (options) => interpolatePath("/other-requests", undefined, options?.search, options?.hash),
    },
    LocationOtherRequestsRoute: {
        to: "/locations/:slug/other-requests",
        build: (options) => interpolatePath("/locations/:slug/other-requests", options.params, options?.search, options?.hash),
    },
    AddOtherRequestsRoute: {
        to: "/other-requests/add",
        build: (options) => interpolatePath("/other-requests/add", undefined, options?.search, options?.hash),
    },
    LocationAddOtherRequestsRoute: {
        to: "/locations/:slug/other-requests/add",
        build: (options) => interpolatePath("/locations/:slug/other-requests/add", options.params, options?.search, options?.hash),
    },
    EditOtherRequestsRoute: {
        to: "/other-requests/:itemId/edit",
        build: (options) => interpolatePath("/other-requests/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditOtherRequestsRoute: {
        to: "/locations/:slug/other-requests/:itemId/edit",
        build: (options) => interpolatePath("/locations/:slug/other-requests/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewOtherRequestsRoute: {
        to: "/other-requests/:itemId",
        build: (options) => interpolatePath("/other-requests/:itemId", options.params, options?.search, options?.hash),
    },
    LocationViewOtherRequestsRoute: {
        to: "/locations/:slug/other-requests/:itemId",
        build: (options) => interpolatePath("/locations/:slug/other-requests/:itemId", options.params, options?.search, options?.hash),
    },
    RetailRoute: {
        to: "/retail",
        build: (options) => interpolatePath("/retail", undefined, options?.search, options?.hash),
    },
    LocationRetailRoute: {
        to: "/locations/:slug/retail",
        build: (options) => interpolatePath("/locations/:slug/retail", options.params, options?.search, options?.hash),
    },
    AddRetailRoute: {
        to: "/retail/add",
        build: (options) => interpolatePath("/retail/add", undefined, options?.search, options?.hash),
    },
    LocationAddRetailRoute: {
        to: "/locations/:slug/retail/add",
        build: (options) => interpolatePath("/locations/:slug/retail/add", options.params, options?.search, options?.hash),
    },
    EditRetailRoute: {
        to: "/retail/:itemId/edit",
        build: (options) => interpolatePath("/retail/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditRetailRoute: {
        to: "/locations/:slug/retail/:itemId/edit",
        build: (options) => interpolatePath("/locations/:slug/retail/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewRetailRoute: {
        to: "/retail/:itemId",
        build: (options) => interpolatePath("/retail/:itemId", options.params, options?.search, options?.hash),
    },
    LocationViewRetailRoute: {
        to: "/locations/:slug/retail/:itemId",
        build: (options) => interpolatePath("/locations/:slug/retail/:itemId", options.params, options?.search, options?.hash),
    },
    ServicesRoute: {
        to: "/services",
        build: (options) => interpolatePath("/services", undefined, options?.search, options?.hash),
    },
    LocationServicesRoute: {
        to: "/locations/:slug/services",
        build: (options) => interpolatePath("/locations/:slug/services", options.params, options?.search, options?.hash),
    },
    AddServiceRoute: {
        to: "/services/add",
        build: (options) => interpolatePath("/services/add", undefined, options?.search, options?.hash),
    },
    LocationAddServiceRoute: {
        to: "/locations/:slug/services/add",
        build: (options) => interpolatePath("/locations/:slug/services/add", options.params, options?.search, options?.hash),
    },
    EditServiceRoute: {
        to: "/services/:itemId/edit",
        build: (options) => interpolatePath("/services/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditServiceRoute: {
        to: "/locations/:slug/services/:itemId/edit",
        build: (options) => interpolatePath("/locations/:slug/services/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewServiceRoute: {
        to: "/services/:itemId",
        build: (options) => interpolatePath("/services/:itemId", options.params, options?.search, options?.hash),
    },
    LocationViewServiceRoute: {
        to: "/locations/:slug/services/:itemId",
        build: (options) => interpolatePath("/locations/:slug/services/:itemId", options.params, options?.search, options?.hash),
    },
    JobsRoute: {
        to: "/jobs",
        build: (options) => interpolatePath("/jobs", undefined, options?.search, options?.hash),
    },
    LocationJobsRoute: {
        to: "/locations/:slug/jobs",
        build: (options) => interpolatePath("/locations/:slug/jobs", options.params, options?.search, options?.hash),
    },
    AddJobRoute: {
        to: "/jobs/add",
        build: (options) => interpolatePath("/jobs/add", undefined, options?.search, options?.hash),
    },
    LocationAddJobRoute: {
        to: "/locations/:slug/jobs/add",
        build: (options) => interpolatePath("/locations/:slug/jobs/add", options.params, options?.search, options?.hash),
    },
    EditJobRoute: {
        to: "/jobs/:itemId/edit",
        build: (options) => interpolatePath("/jobs/:itemId/edit", options.params, options?.search, options?.hash),
    },
    LocationEditJobRoute: {
        to: "/locations/:slug/jobs/:itemId/edit",
        build: (options) => interpolatePath("/locations/:slug/jobs/:itemId/edit", options.params, options?.search, options?.hash),
    },
    ViewJobRoute: {
        to: "/jobs/:itemId",
        build: (options) => interpolatePath("/jobs/:itemId", options.params, options?.search, options?.hash),
    },
    LocationViewJobRoute: {
        to: "/locations/:slug/jobs/:itemId",
        build: (options) => interpolatePath("/locations/:slug/jobs/:itemId", options.params, options?.search, options?.hash),
    },
    PermissionManagementRoute: {
        to: "/admin/permissions",
        build: (options) => interpolatePath("/admin/permissions", undefined, options?.search, options?.hash),
    },
    ApprovalDashboardRoute: {
        to: "/admin/approvals",
        build: (options) => interpolatePath("/admin/approvals", undefined, options?.search, options?.hash),
    },
    RecycleBinRoute: {
        to: "/admin/recycle-bin",
        build: (options) => interpolatePath("/admin/recycle-bin", undefined, options?.search, options?.hash),
    },
    AdminReportsRoute: {
        to: "/admin/reports",
        build: (options) => interpolatePath("/admin/reports", undefined, options?.search, options?.hash),
    },
    AdminGlobalSettingsRoute: {
        to: "/admin/global-settings",
        build: (options) => interpolatePath("/admin/global-settings", undefined, options?.search, options?.hash),
    },
    MaintenanceRoute: {
        to: "/maintenance",
        build: (options) => interpolatePath("/maintenance", undefined, options?.search, options?.hash),
    },
    NotFoundRoute: {
        to: "*",
        build: (options) => interpolatePath("*", options.params, options?.search, options?.hash),
    },
};
// PUBLIC API
export { Link } from './Link';
//# sourceMappingURL=index.js.map